import { Footer, ServiceUnavailable } from '@b2c/ui';
import classNames from 'classnames';
import { useContext, useMemo } from 'react';
import { LayoutHeader } from './layout-header';
import styles from './layout.module.less';
import { AppContextInfoContext } from '@b2c/hooks';

export function Layout({ children, theme }) {
  const layoutModifier = useMemo(() => {
    return {
      white: styles.theme_white,
    }[theme];
  }, [theme]);
  const unavailable = !!(useContext(AppContextInfoContext).appContext?.unavl);
  const body = unavailable ? (
    <ServiceUnavailable siteName="HotelWhales" variant="split" />
  ) : (
    <>
      <div className={styles.layoutBody}>
        <div className={styles.layoutContainer}>
          <LayoutHeader></LayoutHeader>
          {children}
        </div>
      </div>
      <div className={styles.layoutFooter}>
        <div className={styles.layoutContainer}>
          <Footer
            brandName="HotelWhales"
            WebSiteName="HotelWhales.com"
          ></Footer>
        </div>
      </div>
    </>
  );

  return (
    <div className={classNames(styles.layout, layoutModifier)}>
      {body}
    </div>
  );
}
